<template>
  <a-form
    :layout="formLayout"
    :form="form"
    @submit="handleSubmit"
  >
    <a-form-item label="Начало рабочего дня (МСК)">
      <div>
        <a-time-picker
          v-decorator="[
            'daystart',
            {
              rules: [{ required: true, message: 'Укажите начало рабочего дня' }],
            },
          ]"
          :minute-step="15"
          format="HH:mm" 
          :default-open-value="moment('00:00', 'HH:mm')"
          @change="setDayStart"
        />
      </div>
    </a-form-item>
    <a-form-item label="Конец рабочего дня (МСК)">
      <div>
        <a-time-picker
          v-decorator="[
            'dayend',
            {
              rules: [{ required: true, message: 'Укажите начало рабочего дня' }],
            },
          ]"
          :minute-step="15"
          format="HH:mm" 
          :default-open-value="moment('19:00', 'HH:mm')"
          @change="setDayEnd"
        />
      </div>
    </a-form-item>
    <a-form-item label="Кол-во звонков за день">
      <a-input-number
        v-decorator="[
          'calls',
          {
            rules: [{ required: true, message: 'Впишите число' }],
          },
        ]"
        style="width: 150px"
      />
    </a-form-item>
    <a-form-item label="Кол-во минут за день">
      <a-input-number
        v-decorator="[
          'minutes',
          {
            rules: [{ required: true, message: 'Впишите число' }],
          },
        ]"
        style="width: 150px"
      />
    </a-form-item>
     <a-form-item>
      <a-button type="primary" html-type="submit">
        Сохранить
      </a-button>
    </a-form-item>
  </a-form>
</template>
<script>
import bent from 'bent';
import moment from 'moment'

export default {
  props: [
    'initialData',
    'baseUrl',
    'callsSettings',
    'panelId',
    'password',
    'adminpassword',
  ],
  components: {},
  data() {
    return {
      moment: moment,
      dayEnd: null,
      dayStart: null,
      formLayout: 'vertical',
      form: this.$form.createForm(this, { name: 'coordinated' }),
      post: {},
    };
  },
  async mounted() {
    this.post = bent(this.baseUrl, 'POST', 'json', 200);
    this.init();
  },
  computed: {},
  watch: {
    callsSettings(value) {
      setTimeout(() => {
        this.form.setFieldsValue({
          calls: value.calls,
          minutes: value.minutes,
          daystart: moment(value.daystart, 'HH:mm'),
          dayend: moment(value.dayend, 'HH:mm')
        });
      }, 0);
    },
  },
  methods: {
    async init() {
      setTimeout(() => {
        this.form.setFieldsValue({
          calls: this.callsSettings.calls,
          minutes: this.callsSettings.minutes,
          daystart: moment(this.callsSettings.daystart, 'HH:mm'),
          dayend: moment(this.callsSettings.dayend, 'HH:mm')
        });
        this.dayStart = this.callsSettings.daystart,
        this.dayEnd = this.callsSettings.dayend
      }, 0);
    },
    setDayEnd(_, timeString) {
      this.dayEnd = timeString
    },
    setDayStart(_, timeString) {
      this.dayStart = timeString
    },
    async saveCallsSettings(settings) {
      try {
        await this.post('saveCallsSettings', {
          panelId: this.panelId,
          password: this.password,
          adminpassword: this.adminpassword,
          settings: {
            calls: settings.calls, 
            minutes: settings.minutes,
            daystart: this.dayStart, 
            dayend: this.dayEnd
          }
        });
      } catch (error) {
        console.log(error);
        alert('Ошибка сохранения');
      }
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, settings) => {
        if (!err) {
          await this.saveCallsSettings({
            ...settings
          });
          this.$emit('callsChange', settings);
        }
      });
    }
  },
};
</script>
<style scoped>

</style>
